import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "dash-btn",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick')))
  }, [
    _createTextVNode(_toDisplayString($props.text) + " ", 1),
    _createElementVNode("i", {
      class: _normalizeClass(["icon-arrow_right", $props.classNm])
    }, null, 2)
  ]))
}